import React from "react";

import { useTranslation } from "i18n";

const PassportLoading = ({ image, fileType }) => {
  const { t } = useTranslation();
  const isPdf = fileType === "application/pdf";

  return (
    <div className="pp-scan-overlay">
      <div className="pp-scan-card">
        <div className="pp-scan-viewport">
          {isPdf ? (
            <iframe
              className="pp-scan-doc"
              src={image}
              title="passport-preview"
              frameBorder="0"
            />
          ) : (
            <img className="pp-scan-doc" src={image} alt="passport-preview" />
          )}

          <div className="pp-scan-veil" />
          <div className="pp-scan-beam" />

          <span className="pp-scan-corner pp-scan-corner--tl" />
          <span className="pp-scan-corner pp-scan-corner--tr" />
          <span className="pp-scan-corner pp-scan-corner--bl" />
          <span className="pp-scan-corner pp-scan-corner--br" />
        </div>

        <div className="pp-scan-status">
          <span className="pp-scan-spinner" aria-hidden="true" />
          <div className="pp-scan-status-copy">
            <p>{t("booking.labels.scanningTitle")}</p>
            <span>{t("booking.labels.scanningHint")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassportLoading;
